import React, { createContext, useContext, useState, useEffect } from 'react';

const GuestContext = createContext();

export function useGuest() {
    return useContext(GuestContext);
}

export function GuestProvider({ children }) {
    const [guestToken, setGuestToken] = useState(localStorage.getItem('guestToken'));
    const [guestGroup, setGuestGroup] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (guestToken) {
            fetchGuestData();
        } else {
            setLoading(false);
        }
    }, [guestToken]);

    const fetchGuestData = async () => {
        try {
            const response = await fetch('/api/guest/me', {
                headers: {
                    'Authorization': `Bearer ${guestToken}`
                }
            });

            if (response.ok) {
                const data = await response.json();
                setGuestGroup(data.group);
            } else {
                logout();
            }
        } catch (error) {
            console.error('Error fetching guest data:', error);
            logout();
        } finally {
            setLoading(false);
        }
    };

    const login = async (accessCode) => {
        try {
            const response = await fetch('/api/guest/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ accessCode })
            });

            if (response.ok) {
                const data = await response.json();
                localStorage.setItem('guestToken', data.token);
                setGuestToken(data.token);
                setGuestGroup(data.group);
                return { success: true };
            } else {
                return { success: false, error: 'Invalid access code' };
            }
        } catch (error) {
            console.error('Login error:', error);
            return { success: false, error: 'Login failed' };
        }
    };

    const logout = () => {
        localStorage.removeItem('guestToken');
        setGuestToken(null);
        setGuestGroup(null);
    };

    const submitRSVP = async (members) => {
        try {
            const response = await fetch('/api/guest/rsvp', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${guestToken}`
                },
                body: JSON.stringify({ members })
            });

            if (response.ok) {
                const data = await response.json();
                setGuestGroup(data.group);
                return { success: true };
            } else {
                return { success: false, error: 'Failed to submit RSVP' };
            }
        } catch (error) {
            console.error('RSVP error:', error);
            return { success: false, error: 'Failed to submit RSVP' };
        }
    };

    return (
        <GuestContext.Provider value={{
            guestToken,
            guestGroup,
            loading,
            login,
            logout,
            submitRSVP,
            isGuest: !!guestToken
        }}>
            {children}
        </GuestContext.Provider>
    );
}
